import { render, staticRenderFns } from "./CashierSvg.vue?vue&type=template&id=b4514888&scoped=true"
import script from "./CashierSvg.vue?vue&type=script&lang=js"
export * from "./CashierSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4514888",
  null
  
)

export default component.exports